import { Button } from "@/components";
import styles from "./patners-card.module.scss";
import Icon from "@/components/Icon";
import { SubscriptionCard } from "@/components";
import { useSubscription } from "@/contexts/SubscriptionProvider";
import { useEffect, useRef } from "react";
import { useSubscriptionToken } from "@/hooks/useSubscriptionToken";

interface cardProps {
  setVisible: React.Dispatch<React.SetStateAction<number>>;
}

export default function PartnersCard({ setVisible }: cardProps) {
  const { subscription, loading, refetchSubscription } = useSubscription();

  const { isLoading } = useSubscriptionToken();

  const appState = useRef("active");

  const item =
    subscription?.subscription && subscription.subscription.partnerSessions;
  useEffect(() => {
    let inactivityTimer: any;

    const handleActivity = () => {
      if (appState.current === "inactive") {
        refetchSubscription();
      }

      appState.current = "active";
      clearTimeout(inactivityTimer);

      inactivityTimer = setTimeout(() => {
        appState.current = "inactive";
      }, 5 * 60 * 1000);
    };

    inactivityTimer = setTimeout(() => {
      appState.current = "inactive";
    }, 5 * 60 * 1000);

    window.addEventListener("mousemove", handleActivity);
    window.addEventListener("keypress", handleActivity);
    window.addEventListener("click", handleActivity);

    return () => {
      clearTimeout(inactivityTimer);
      window.removeEventListener("mousemove", handleActivity);
      window.removeEventListener("keypress", handleActivity);
      window.removeEventListener("click", handleActivity);
    };
  }, [refetchSubscription]);

  return loading || isLoading ? (
    <p>Loading</p>
  ) : !subscription?.isSubscribed ? (
    <SubscriptionCard />
  ) : (
    <article className={styles.patnerCard}>
      <div className="headerx">
        <h2 className={styles.heading}>Language Partner Sessions</h2>
        <p className={styles.sub_heading}>
          Speak better by practicing with native speakers
        </p>
      </div>

      <div>
        <div>
          You are entitled to {item?.entitledPerWeek} partner session per week.
        </div>
        <div className={styles.info}>
          <Icon name="checks" />
          Pick a date and time that suits you.
        </div>
        <div className={styles.info}>
          <Icon name="checks" color="#169fed" />
          Choose a partner
        </div>
      </div>

      <div className={styles.slots_available}>
        <div>Your Available Session Slots</div>
        <div style={{ fontWeight: "700", fontSize: "34px" }}>
          {item?.remainingThisWeek}
        </div>
      </div>

      <Button variant="primary" onClick={() => setVisible(1)}>
        Book A Session
      </Button>
    </article>
  );
}
